import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

export const useGetQuestions = ({ id }: { id: string }) => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const t = useI18n();
  const wasPolling = useRef(false);

  const query = useQuery(
    trpc.questions.getWithFileNames.queryOptions(
      { id },
      {
        refetchInterval: (data) =>
          data?.state.data?.status.shouldPoll ? 5000 : false,
      },
    ),
  );

  // Handle toast notifications for processing status
  useEffect(() => {
    const isPolling = query.data?.status?.shouldPoll;
    const everyFailed = query.data?.status?.everyFailed;
    const errorMessage = query.data?.status?.errorMessage;

    if (isPolling) {
      wasPolling.current = true;
    } else if (wasPolling.current) {
      wasPolling.current = false;
      if (!everyFailed) {
        toast.success(t("studySet.questions.processing.complete"), {
          description: t("studySet.questions.processing.completeDescription"),
        });
      } else {
        toast.error(t("studySet.questions.processing.failed"), {
          description:
            errorMessage ||
            t("studySet.questions.processing.failedDescription"),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.users.getPlanLimit.queryKey(),
        });
      }
    }
  }, [
    query.data?.status?.shouldPoll,
    query.data?.status?.everyFailed,
    query.data?.status?.errorMessage,
    t,
    queryClient,
    trpc.users.getPlanLimit.queryKey,
  ]);

  return query;
};
